export class Token {
    private name: string;
    
    constructor(name: string) {
        this.name = name;    
    }
    
    toString(): string {
        return `Token ${this.name}`;
    }
}

export type RegistrationToken = string | Token;

export interface IInjector {
    createChildInjector(): IInjector;
    register(token: RegistrationToken, type: Function, dependencies?: string[]): void;
    registerFactory<T>(token: RegistrationToken, factory: (injector: IInjector) => T): void;
    resolve<T>(token: RegistrationToken | Function, locals?: any, path?: any[]): T;
}